import { Middleware } from "redux";

const localStorageMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  if (action.type.startsWith("config/")) {
    localStorage.setItem("config", JSON.stringify(store.getState().config));
  } else if (action.type.startsWith("profile/")) {
    localStorage.setItem("profiles", JSON.stringify(store.getState().profile.profiles));
  }

  return result;
};

export default localStorageMiddleware;
